import { useMemo } from 'react';
import {
  DATE_FORMAT_DISPLAY_MONTH_DAY,
  DATE_FORMAT_DISPLAY_MONTH_YEAR,
} from '@fortress-technology-solutions/fortress-component-library/utils';
import ApprovedAmountCell from '../ApprovedAmountCell';
import { VARIANCE_CELL_SX } from '../constants';
import { canEditApprovedAmount } from '../utils';

const numberFormatOptions = {
  minimumFractionDigits: 2,
};
const useRows = ({
  results,
  hasVariance = false,
  isReadOnly = false,
  onSaveApprovedAmount,
  propertyId,
  canManage,
}) => {
  return useMemo(() => {
    return results.map((result) => ({
      id: result.id,
      headOfHousehold: {
        variant:
          result.isVacant || !result.headOfHouseholdResidentId
            ? 'string'
            : 'link',
        to: result.headOfHouseholdResidentId
          ? `/property/${propertyId}/resident/${result.headOfHouseholdResidentId}`
          : undefined,
        value: result.headOfHousehold,
      },
      unit: {
        variant: 'link',
        to: `/property/${propertyId}/unit/${result.unitId}`,
        value: result.unit,
      },
      hudUnitNumber: {
        value: result.hudUnitNumber,
      },
      bedsBaths: {
        value: result.bedsBaths,
      },
      contractRent: {
        variant: 'currency',
        value:
          result.contractRent === null || result.contractRent === undefined
            ? 0
            : result.contractRent,
        numberFormatOptions,
      },
      utilityAllowance: {
        variant: 'currency',
        value:
          result.utilityAllowance === null ||
          result.utilityAllowance === undefined
            ? 0
            : result.utilityAllowance,
        numberFormatOptions,
      },
      grossRent: {
        variant: 'currency',
        value:
          result.grossRent === null || result.grossRent === undefined
            ? 0
            : result.grossRent,
        numberFormatOptions,
      },
      incomeCode: {
        value: result.incomeCode,
      },
      turnoverCode: {
        value: result.turnoverCode,
      },
      turnoverMonthDay: {
        variant: 'date',
        value: result.turnoverMonthDay,
        dateFormat: DATE_FORMAT_DISPLAY_MONTH_DAY,
      },
      nextRecertDate: {
        variant: 'date',
        value: result.nextRecertDate,
        dateFormat: DATE_FORMAT_DISPLAY_MONTH_YEAR,
      },
      changeCode: {
        value: result.changeCode,
      },
      requestedAmount: {
        variant: 'currency',
        value:
          result.requestedAmount === null ||
          result.requestedAmount === undefined ||
          Number.isNaN(result.requestedAmount)
            ? 0
            : result.requestedAmount,
        numberFormatOptions,
      },
      approvedAmount: canEditApprovedAmount(hasVariance, isReadOnly, canManage)
        ? {
            sx: VARIANCE_CELL_SX,
            value: (
              <ApprovedAmountCell
                key={result.id}
                initialValue={result.approvedAmount}
                onSave={(amount) => onSaveApprovedAmount?.(result, amount)}
              />
            ),
          }
        : {
            variant: 'currency',
            value: result.approvedAmount,
            numberFormatOptions,
          },
    }));
  }, [
    results,
    hasVariance,
    isReadOnly,
    onSaveApprovedAmount,
    propertyId,
    canManage,
  ]);
};

export default useRows;
